<template>
  <div class="login">
    <img class="logo" src="../../assets/icon.png">
    <h1>Welcome to Charles</h1>
    <el-form :model="form"
             :rules="rules"
             ref="form"
             label-position="top"
             v-loading.fullscreen.lock="loading"
             :element-loading-text="'Logging in...'"
             class="login-form">
      <el-form-item label="Email" prop="email">
        <el-input v-model="form.email" />
      </el-form-item>
      <el-form-item label="Password" prop="password">
        <el-input type="password" v-model="form.password"  />
      </el-form-item>
      <el-button type="primary"
                 class="login-btn"
                 @click="login"
                 v-shortkey.once="['enter']"
                 @shortkey.native="login"
      >Login</el-button>
    </el-form>
  </div>
</template>

<script>
import {CLIENT_ID, CLIENT_SECRET} from '../../config'
import router from '../../util/router'

export default {
  name: 'login',
  data () {
    return {
      loading: false,
      form: {
        email: '',
        password: ''
      },
      rules: {
        email: [
          { required: true, message: 'Email Address is required', trigger: 'blur' },
          { type: 'email', message: 'Email Address is not in valid format', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Password is required', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // Login handler
    login () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true
          // Send the Login request to the API
          var data = {
            grant_type: 'password',
            client_id: CLIENT_ID,
            client_secret: CLIENT_SECRET,
            username: this.form.email,
            password: this.form.password,
            scope: '*'
          }
          this.$http.post('oauth/token', data).then((response) => {
            this.loading = false
            // Login was a success. Store the API token and redirect to the rest of the app
            this.$store.dispatch('login', response.body.access_token)
            this.$store.dispatch('getCurrentUser')
            router.push('/')
          }, () => {
            // Login was not successful. Hide overlay and show errors
            this.loading = false
            this.$message.error('Email and/or Password incorrect!')
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less">
  .login-form {
    max-width: 320px;
    margin: auto;

    label {
      line-height: 1em;
    }
  }
  .login {
    padding: 30px;
    text-align: center;

    h1 {
      font-size: 22px;
      line-height: 1.6;
      margin-bottom: 50px;
    }
    .logo {
      max-width: 100px;
      width: 100%;
      height: auto;
      margin: 10px auto 20px auto;
      display: block;
    }
    .login-btn {
      width: 100%;
      margin-top: 20px;
    }
  }
</style>
